/**
 * Splits a file name into a stem and an extension.
 *
 * @param fileName
 */
export function splitFileName(
  fileName: string,
): [stem: string, extension: string | null] {
  const parts = fileName.split('.')
  if (parts.length === 1) {
    return [parts[0], null]
  }

  const extension = parts.pop() || null
  const stem = parts.join('.')
  return [stem, extension]
}

/**
 * Formats a file size to a string.
 *
 * @param size The size in bytes.
 */
export function formatSize(size: number): string {
  // We really only need the first 4 or so, but doesn't hurt to add the rest
  const sizeSuffixes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let s = size
  let n = intDiv(s, 1024)
  let i = 0
  while (n > 0) {
    s = n
    n = intDiv(n, 1024)
    i += 1
  }

  return `${s}${sizeSuffixes[i]}`
}

/**
 * Integer division.
 * @param a
 * @param b
 */
function intDiv(a: number, b: number): number {
  const result = a / b
  if (result >= 0) {
    return Math.floor(result)
  } else {
    return Math.ceil(result)
  }
}
